export const MYBT_ONBOARD_SUBSCRIBE_FOR_MORE_URL =
  "https://subscribe.sph.com.sg/publications-bt/?utm_campaign=bt_subscription&utm_medium=sph-publication&utm_source=bt&utm_content=mybt";
